import { render, staticRenderFns } from "./WonderTopicBacktest.vue?vue&type=template&id=93bd8336&scoped=true"
import script from "./WonderTopicBacktest.vue?vue&type=script&lang=js"
export * from "./WonderTopicBacktest.vue?vue&type=script&lang=js"
import style0 from "./WonderTopicBacktest.vue?vue&type=style&index=0&id=93bd8336&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93bd8336",
  null
  
)

export default component.exports